module.exports = __webpack_public_path__ + "static/media/ViewBtn.1d8c5570.svg";